import { useEffect } from 'react';
import { raiseIntent } from '@finos/fdc3';
import { PreferenceKey, useGlobalPreference } from '#features/preferences';
import { focusSmartBarAction } from '#platform/hotkeys/actions';
import {
  getHotkeyKeyFromMouseEvent,
  getHotkeyModifierFromMouseEvent,
} from '#platform/hotkeys/mappers';

export const useSmartBarFocusHotkey = () => {
  const useHotkeysPreference = useGlobalPreference(PreferenceKey.useHotkeys);
  const hotkeySmartBarFocusPreference = useGlobalPreference(
    PreferenceKey.hotkeySmartBarFocus,
  );

  useEffect(() => {
    if (!useHotkeysPreference) {
      return;
    }

    const keydownListener = async (event: KeyboardEvent) => {
      const { modifier, key } = hotkeySmartBarFocusPreference;

      if (
        getHotkeyModifierFromMouseEvent(event) === modifier &&
        getHotkeyKeyFromMouseEvent(event) === key
      ) {
        await raiseIntent(
          focusSmartBarAction.intent,
          focusSmartBarAction.context,
          {
            appId: fin.me.uuid,
          },
        );
      }
    };

    document.addEventListener('keydown', keydownListener);

    return () => document.removeEventListener('keydown', keydownListener);
  }, [useHotkeysPreference, hotkeySmartBarFocusPreference]);

  return null;
};
